// src/components/InputArea.jsx
import React, { useRef, useEffect, useState } from "react";
import css from "./InputArea.module.css";

export const InputArea = ({
  label,
  name,
  value,
  onChange,
  error,
  onBlur,
  required = false,
  maxLength = null,
  placeholder = " ",
  rows = 6, // ajuste padrão; pode passar outra quantidade
  id = null,
}) => {
  const textareaRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const inputId = id || name;
  const errorId = `${inputId}-error`;

  // Auto-resize the textarea to its content
  useEffect(() => {
    const ta = textareaRef.current;
    if (!ta) return;
    // reset height so scrollHeight is recalculated
    ta.style.height = "auto";
    // add 2px to avoid small scrollbar on some browsers
    ta.style.height = `${ta.scrollHeight + 2}px`;
  }, [value, rows]);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur && onBlur(e);
  };

  const filled = Boolean(value && String(value).trim().length > 0);

  return (
    <div className={css.wrapper}>
      <div className={css.field}>
        <textarea
          id={inputId}
          name={name}
          ref={textareaRef}
          className={`${css.textarea} ${error ? css.textareaError : ""}`}
          rows={rows}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          maxLength={maxLength || undefined}
          placeholder={placeholder}
          autoComplete="off"
          aria-invalid={!!error}
          aria-describedby={error ? errorId : undefined}
          required={required}
        />
        <label
          htmlFor={inputId}
          className={`${css.label} ${isFocused || filled ? css.labelUp : ""} ${
            error ? css.labelError : ""
          }`}
        >
          {label}
          {required && (
            <span aria-hidden="true" className={css.required}>
              *
            </span>
          )}
        </label>
      </div>

      <div className={css.meta}>
        {maxLength ? (
          <div className={css.counter}>
            {String(value || "").length}/{maxLength}
          </div>
        ) : (
          <div />
        )}

        {error && (
          <p id={errorId} className={css.error}>
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

export default InputArea;
